<template lang="pug">
  .component-body.full-size
    nav
      ul
        div(
          v-for="item in items", :key="item.id"
        )
          el-tooltip#tooltip(
            v-if="mostrarMenu(item.permissao) || item.permissao === 'CAIXA_PROCESSO'"
            effect='dark',
            :content="item.nome.split('_')[0]",
            :disabled ="(item.nome.length < 26 && windowWidth > 1365)",
            placement="right"
          )
            li.menu-item(
              :class="{'active': $route.meta.routeGroup == item.routeName}",
              @click.stop="goTo(item.routeName)"
            )
              .menu-group(:id="`menu-side-${item.routeName}`")
                span(v-if="item.icon.includes('img')")
                  img.iconeImg(:src="buscarIcone(item.icon.split('-')[0])", alt="icone")
                font-awesome-icon(v-else :icon="item.icon")
                .menu-text(v-if="item.nome.split('_')[0].length > 25")
                  p {{ item.nome.split('_')[0].slice(0,25) }}...
                .menu-text(v-if="item.nome.length <= 25")
                  p {{ item.nome.split('_')[0].slice(0,25) }}
</template>

<script>
import { mapGetters } from 'vuex'
import PermissaoHelper from '../screens/analise/PermissaoHelper'
import IconMixin from '../screens/manutencao/mixin/IconMixin.vue'
export default {

  data () {
    return {
      windowWidth: 0,
      activeMenu: 'CAIXA_DE_ENTRADA'
    }
  },

  mixins: [
    PermissaoHelper,
    IconMixin
  ],

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  created () {
    this.$nextTick(function () { // eslint-disable-line
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    goTo (params) {
      this.activeMenu = params
      this.$router.push({
        name: params
      })
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },

    buscarIcone (icon) {
      return this.imagens[icon]
    },

    mostrarMenu (permissao) {
      const permissoes = this.usuario.permissoes || []
      return !!permissoes.find(p => p.codigo === permissao)
    },

    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth
    },

    getNome (nome) {
      return nome.split('_')[0]
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
  }

}
</script>

<style lang="scss" scoped>
.component-body {
  width: 150px;
  display: flex;
  position: relative;
  background-color: #f3f7fa;
  height: 100%;
  min-height: 105vh;

  nav {
    width: 150px;
    color: #606266;
    -webkit-box-shadow: 0px 0px 7px -5px #eaeef1;
    box-shadow: 8px 0px 7px -5px #eaeef1;

    ul {
      padding: 0;
      margin: 0;
    }

    .menu-item {
      padding: 5px;
      height: 85px;
      display: flex;
      align-items: center;
      transition: hover 1s;

      .menu-group {
        width: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;

        i {
          font-size: 20px;
        }
      }
    }

    .menu-item:hover {
      cursor: pointer;
      background-color: rgba(0, 159, 97, 0.1);
      -webkit-transition: background-color 0.2s ease-out;
      -moz-transition: background-color 0.2s ease-out;
      -o-transition: background-color 0.2s ease-out;
      transition: background-color 0.2s ease-out;
    }
  }
  .iconeImg {
    width: 20px;
  }
}

.active {
  color: #009f61;
  background: linear-gradient(-45deg, #009f61 0%, #009f61 7%, white 0%);
}

.menu-text {
  margin-top: 5px;
}

@media (max-width: 780px){
  .component-body {
    width: 33px !important;
  }
}

@media (max-width: 1365px) {
  .component-body {
    width: 60px;
    nav {
      .menu-item {
        height: 50px;
      }
    }
  }
  .menu-icon {
    font-size: 20px;
    margin-top: 10px;
  }
  .menu-text {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideMenuLazy.vue